module.exports = "<div class=\"igx-date-picker\">\n    <input class=\"igx-date-picker__input-date\" igxInput (click)=\"onOpenEvent($event)\" [value]=\"displayData\" [disabled]=\"isDisabled\" />\n    <igx-dialog class=\"igx-date-picker__dialog-popup\" closeOnOutsideSelect=\"true\"\n        [leftButtonLabel]=\"cancelButtonLabel\" (onLeftButtonSelect)=\"alert.close()\"\n        [rightButtonLabel]=\"todayButtonLabel\" (onRightButtonSelect)=\"triggerTodaySelection()\">\n        <ng-container #container></ng-container>\n    </igx-dialog>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/date-picker/date-picker.component.html
// module id = 146
// module chunks = 0 1